import { render, staticRenderFns } from "./EmailHeaderFooter.vue?vue&type=template&id=1c553e3a"
import script from "./EmailHeaderFooter.vue?vue&type=script&lang=js"
export * from "./EmailHeaderFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports